export default __webpack_public_path__ + "images/52ffedb1c753d9a680ec52e63fe2fadb-motorsports.webp";